export type DeleteIfConversionRulesResponse = {};
